import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import NewSale from "./NewSale";

const Index = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [items, setItems] = useState([
    {
      id: Math.random(),
      product_name: "",
      quantity: "",
      net_price: "",
      sub_total: "",
      bar_code: "",
    },
  ]);

  const onSubmit = (data) => {
    console.log({ ...data, items });
  };

  const handleRemove = (id) => {
    const filter = items.filter((it) => it.id !== id);
    setItems(filter);
  };

  const sumTotal = () => {
    let total = 0;
    items.map((it) => {
      total += it.sub_total;
    });
    return total;
  };

  return (
    <div className="w-10/12 mx-auto my-5">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-between items-center flex-col sm:flex-row">
          <h1 className="text-3xl">New Sales</h1>
          <div>
            <input
              type="submit"
              value="Save"
              className="btn btn-active text-white rounded-none mt-5 sm:mt-0 w-full sm:w-auto mx-2"
            />
            <a
              href="##"
              className="btn btn-active text-white rounded-none mt-5 sm:mt-0 w-full sm:w-auto mx-2"
            >
              Share Invoice
            </a>
          </div>
          {/* Save & Get Invoice
          </input> */}
        </div>
        <div>
          <div className="grid gird-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              id="customer_name"
              placeholder="Customer Name*"
              className={
                errors.customer_name
                  ? "input input-error w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
                  : "input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
              }
              {...register("customer_name", {
                required: {
                  value: true,
                  message: "*Required",
                },
                validate: (val) => {
                  return val.trim() !== "" || "*Required";
                },
              })}
              required
            />
            <input
              type="text"
              id="customer_phone"
              placeholder="Customer Phone Number*"
              className={
                errors.supplier_phone
                  ? "input input-error w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
                  : "input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
              }
              {...register("customer_phone", {
                required: {
                  value: true,
                  message: "*Required",
                },
                validate: (val) => {
                  return val.trim() !== "" || "*Required";
                },
              })}
              required
            />
          </div>
          <div className="">
            {items.map((item, index) => {
              return (
                <NewSale
                  index={index}
                  key={item.id}
                  item={item}
                  setItems={setItems}
                  handleRemove={handleRemove}
                />
              );
            })}
          </div>

          <a
            href="##"
            onClick={() => {
              setItems([...items, { id: Math.random() }]);
            }}
            className="btn btn-success text-white rounded-none mt-5 w-full text-center flex items-center"
          >
            <i className="fa-solid fa-plus mr-2"></i> New Item
          </a>
          <h2 className="mt-5 text-2xl font-semibold">
            Total: {sumTotal()}
            <span className="text-sm ml-1">tk</span>
          </h2>
        </div>
      </form>
    </div>
  );
};

export default Index;
